import {z} from 'zod';
import {baseCardSchema} from './baseSchemas';
import {NodeType} from 'common/src/modules/nodes/nodes.types';
import {LocationTargetingMethodValue} from 'common/src/modules/locationFeed/locationFeed.types';

const locationStartegyValueToName = {
  [LocationTargetingMethodValue.NearestLocation]: 'Nearest Location',
  [LocationTargetingMethodValue.ByZipCode]: 'By Zip Code',
  [LocationTargetingMethodValue.ByZipCodeFromDsp]: 'By Zip Code From DSP',
  [LocationTargetingMethodValue.ByDMA]: 'By DMA',
  [LocationTargetingMethodValue.SpecificStore]: 'Specific Store',
};

export const locationCardSchema = baseCardSchema.extend({
  type: z.literal(NodeType.STORE),
  locationTargetingMethod: z
    .nativeEnum(LocationTargetingMethodValue)
    .describe(
      `The location targeting method, should be one of the following: ${Object.values(locationStartegyValueToName).join(', ')}`,
    ),
  locationFeedId: z.number().describe('The location feed ID'),
  locationSetId: z
    .number()
    .nullable()
    .describe('The location set ID, if store targeting method requires it'),
  maxDistKm: z
    .number()
    .default(10)
    .nullable()
    .describe(
      'The max distance from store in km, should be populated if the targeting method is Nearest Location',
    ),
  topLocationIds: z
    .array(z.string())
    .nullable()
    .describe(
      'Specific location ids or names, provided by the user, should be populated if the targeting method is Specific Store',
    ),
});
